export default (node) => {
  /**
   * Data + elements
   */
  const filterButtonMobile = node.querySelector('[data-filter-button]');
  const filterMobileIcon = node.querySelector('[data-filter-icon]');

  /**
   * Functions
   */
  const toggleFilterMobile = () => {
    filterMobileIconRotate();
    // dispatch event to open mobile filter
    document.dispatchEvent(new CustomEvent('filter-mobile:open'));
  };

  const filterMobileIconRotate = () => {
    filterMobileIcon.classList.toggle('rotate-180');
  };

  const initEventListeners = () => {
    const filtersApplied = node.querySelectorAll(
      '[data-filter-button-applied]'
    );
    if (filtersApplied) {
      filtersApplied.forEach((filter) => {
        // dispatch event to apply the filter, passing the button element
        filter.addEventListener('click', () => {
          document.dispatchEvent(
            new CustomEvent('filter-mobile:remove-filter', {
              detail: {
                button: filter,
              },
            })
          );
        });
      });
    }
  };

  /**
   * Init
   */
  const init = () => {
    filterButtonMobile.addEventListener('click', toggleFilterMobile);
    initEventListeners();
    document.addEventListener(
      'collection-filter:add-listeners',
      initEventListeners
    );
    document.addEventListener('filter-mobile:close', filterMobileIconRotate);
  };

  init();
};
